import { render, staticRenderFns } from "./Cx3PbxService.vue?vue&type=template&id=bccb95de&"
import script from "./Cx3PbxService.vue?vue&type=script&lang=js&"
export * from "./Cx3PbxService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports